export const GET_LOAD_TREND = "GET_LOAD_TREND";
export const GET_SIMULATE_TREND = "GET_SIMULATE_TREND";
export const CLEAR_SIMULATE_TREND = "CLEAR_SIMULATE_TREND";
export const SET_FORM_DATA_TREND = "SET_FORM_DATA_TREND";
export const SET_DEFAULT_FORM_DATA_TREND = "SET_DEFAULT_FORM_DATA_TREND";
export const CLEAR_RESPONSE_TREND  = "CLEAR_RESPONSE_TREND";



